import axios from 'axios'
import { Local } from '@/utils/local'
import { message } from 'ant-design-vue';
import {removeAllCookie} from "@/utils/md5";

axios.interceptors.request.use(
  config => {
    config.headers['Cache-Control'] = 'no-cache';
    return config;
  },
  error => {
    Promise.reject(error)
  }
);


axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          message.destroy();
          message.warning('您的账号信息已过期，请重新登录');
          // removeAllCookie()
          break;
        case 401:
          console.log(error)
          message.destroy();
          message.warning('没有传token，请重新登录');
          // removeAllCookie()
          break;
        default:
          message.destroy();
          let { config } = error || {};
          let { url } = config || {};
          let base = 'ai-customer-service/request/log';
          if(url.indexOf(base) == -1) {
            message.error('接口请求失败，请重试');
          }
          break;
      }
    }
    return Promise.reject(error);
  }
);


export default {
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        params
      })
        .then(
          (res) => {
            resolve(res.data);
          },
          (err) => {
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },

  post(url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        // data: qs.stringify(data)
        data
      })
        .then(
          (res) => {
            resolve(res.data);
          },
          (err) => {
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },
  post2(url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        headers:
          {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8'
          },

        data
      })
        .then(
          (res) => {
            resolve(res.data);
          },
          (err) => {
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },

  put(url, data) {
    return new Promise((resolve, reject) => {
      axios.put(url, data)
        .then(
          (res) => {
            resolve(res.data);
          },
          (err) => {
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },

  del(url, data) {
    return new Promise((resolve, reject) => {
      axios.delete(url, data)
        .then(
          (res) => {
            resolve(res.data);
          },
          (err) => {
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/fetch/index.js